export default __webpack_public_path__ + "static/media/card122.a789e6ee.png";